import React, { Component } from 'react';
import Layout from '../components/layout';

import AboutMe from '../components/sections/AboutMe';
import PopupCard from '../components/PopupCard';
import Projects from '../components/sections/Projects';

const initPopupCard = {
  body: '',
  title: '',
  visible: false,
};

class IndexPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dataPopupCard: initPopupCard,
    };

    this.hidePopupCard = this.hidePopupCard.bind(this);
    this.showPopupCard = this.showPopupCard.bind(this);
  }

  hidePopupCard() {
    this.setState({
      dataPopupCard: initPopupCard,
    });
  }

  showPopupCard(dataPopupCard) {
    this.setState({
      dataPopupCard: {
        ...dataPopupCard,
        visible: true,
      },
    });
  }

  render() {
    const { body, title, visible } = this.state.dataPopupCard;

    return (
      <Layout scrollBlock={visible}>
        <AboutMe showPopupCard={this.showPopupCard} />
        <Projects showPopupCard={this.showPopupCard} />
        <PopupCard
          closeCard={this.hidePopupCard}
          title={title}
          visible={visible}
        >
          {body}
        </PopupCard>
      </Layout>
    );
  }
}

export default IndexPage;
